/** Coaching lines on Imposter pass-and-play screens (aligned with Hat tokens). */
export const IMPOSTER_NOTICE_CLASS = "text-typ-ui text-muted-foreground";
